<template>
    <div class="task-calendar-page">
        <div>
            <el-row :gutter="10" class="ml-1 p-2" style="background: #FFFFFF">
                <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
                    <el-date-picker
                        v-if="!form.month"
                        class="w-100 mt-2"
                        v-model="form.year"
                        type="year"
                        value-format="yyyy"
                        format="yyyy"
                        @change="getChartData();form.month=''"
                        placeholder="Chọn năm"
                    />
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
                    <el-date-picker
                        v-model="form.month"
                        class="w-100 mt-2"
                        type="month"
                        value-format="01-MM-yyyy"
                        format="01-MM-yyyy"
                        @change="getChartData();form.year=''"
                        placeholder="Chọn tháng"
                    />
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
                    <el-select
                        v-if="[7,6].includes(keyAccount) || [295391, 266029].includes(currentUser.id)"
                        @change="getChartData(); getCenter()"
                        v-model="form.area_id"
                        placeholder="Chọn Khu vực"
                        filterable
                        collapse-tags
                        clearable
                        class="w-100 mt-2"
                    >
                        <el-option v-for="item in areas" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </el-col>

                <el-col
                    :xs="24" :sm="12" :md="8" :lg="4" :xl="5"
                    v-if="[5,6,7].includes(keyAccount) || [295391, 266029].includes(currentUser.id) || currentUser.profile.account_type_id === 18"
                >
                    <el-select
                        @change="getChartData(); getChildUser(form.branch_id)"
                        v-model="form.branch_id"
                        placeholder="Chọn văn phòng"
                        filterable
                        clearable
                        class="w-100 mt-2"
                    >
                        <el-option
                            v-for="item in branches"
                            :key="item.id"
                            :label="item.name_alias || item.name"
                            :value="item.id"
                        />
                    </el-select>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
                    <tree-select
                        v-model="cache_sale"
                        :normalizer="normalizer"
                        :options="options"
                        :show-count="true"
                        class="w-100 mt-2"
                        placeholder="Chọn nhân sự muốn xem..."
                        search-nested
                        @input="handleChangeSale"
                    >
                        <!--eslint-disable-->
                        <label
                            slot="option-label"
                            slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
                            :class="labelClassName"
                        >
                            <img :src="publicPath + getImageHierarchy(node.raw.profile.account_type.id)" alt="">
                            <span> {{ node.label }} -  {{node.raw.id + 100000}}</span>
                            <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                        </label>
                    </tree-select>
                </el-col>
            </el-row>

            <div class="">
                <div class="charts-grid mt-2 p-1">
                    <!-- Độ tuổi + line HĐ 4A -->
                    <div class="chart-card">
                        <div class="chart-header">
                            <h3 class="chart-title">Độ tuổi khách hàng theo tháng</h3>
                            <p class="chart-sub">
                                Số lượng khách đăng ký chia theo nhóm tuổi trong {{ displayYear }}.
                            </p>
                            <span>
                                Tổng số khách: {{ total }}
                            </span>
                        </div>

                        <apexchart
                            :key="ageChartKey"
                            type="line"
                            height="360"
                            :options="ageChartOptions"
                            :series="ageChartSeries"
                        />
                    </div>

                    <!-- Kênh -->
                    <div class="chart-card">
                        <div class="chart-header">
                            <h3 class="chart-title">Khách hàng theo kênh</h3>
                            <p class="chart-sub">
                                Phân bổ số lượng khách theo từng kênh marketing / nguồn dữ liệu.
                            </p>
                        </div>

                        <apexchart
                            type="bar"
                            height="360"
                            :options="channelChartOptions"
                            :series="channelChartSeries"
                        />
                    </div>

                    <!-- Đối tượng -->
                    <div class="chart-card">
                        <div class="chart-header">
                            <h3 class="chart-title">Đối tượng đăng ký theo tháng</h3>
                            <p class="chart-sub">
                                Học sinh / Sinh viên / Người đi làm trong {{ displayYear }}.
                            </p>
                            <p class="chart-total" v-if="objectTotal">
                                Tổng số khách: {{ objectTotal }}
                            </p>
                        </div>
                        <apexchart
                            type="bar"
                            height="360"
                            :options="objectChartOptions"
                            :series="objectChartSeries"
                        />
                    </div>

                    <div class="chart-card">
                        <div class="chart-header">
                            <h3 class="chart-title">Phím nóng khách hàng</h3>
                            <p class="chart-sub">
                                Tổng số lượt phím nóng theo từng nhóm quan tâm.
                            </p>
                        </div>
                        <apexchart
                            type="bar"
                            height="360"
                            :options="hotKeyChartOptions"
                            :series="hotKeyChartSeries"
                        />
                    </div>

                    <div class="chart-card">
                        <div class="chart-header">
                            <h3 class="chart-title">Khách hàng theo trung tâm</h3>
                            <p class="chart-sub">
                                Khách hàng đăng ký theo từng trung tâm.
                            </p>
                        </div>
                        <apexchart
                            type="bar"
                            height="360"
                            :options="centerChartOptions"
                            :series="centerChartSeries"
                            @dataPointSelection="onCenterPointClick"
                        />
                    </div>
                </div>
            </div>
        </div>
        <el-drawer :visible.sync="drawerCenterVisible">
            <div class="drawer-header p-3">
                <div class="drawer-title">
                    {{ titleStatisticalCenter }}
                </div>
                <div class="drawer-subtitle">
                    Theo chi nhánh ({{ listCustomerBranch.length }} chi nhánh)
                </div>
            </div>

            <div v-if="listCustomerBranch.length" class="drawer-body">
                <div
                    v-for="(item, index) in listCustomerBranch"
                    :key="item.branch_id || index"
                    class="branch-row"
                >
                    <div class="branch-main">
                        <div class="branch-name">
                            <span class="branch-index">{{ index + 1 }}</span>
                            {{ item.branch_name ?? 'Không xác định' }}
                        </div>
                        <div class="branch-id">
                            ID: {{ item.branch_id }}
                        </div>
                    </div>

                    <div class="branch-total">
                        <div class="total-number">
                            {{ item.total_customers }}
                        </div>
                        <div class="total-label">khách</div>
                    </div>
                </div>
            </div>

            <div v-else class="drawer-empty">
                Không có dữ liệu khách theo chi nhánh.
            </div>
        </el-drawer>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { SET_BREADCRUMB } from "../../../core/services/store/breadcrumbs.module";
import { GET_CHART_DATA, GET_REGIONS_BY_USER, GET_CUSTOMER_CHART_BY_CENTER } from "../../../core/services/store/customer/customer.module";
import { BRANCH_LIST, GET_CHILD_USER } from "../../../core/services/store/service.module";
import { mapGetters } from "vuex";

export default {
    name: 'CustomerAnalyticsPage',
    components: {
        apexchart: VueApexCharts
    },
    data () {
        const columnStackedOptions = {
            chart: {
                stacked: true,
                toolbar: { show: true },
                animations: {
                    enabled: true,
                    easing: 'easeinout',
                    speed: 800,
                    animateGradually: { enabled: true, delay: 150 },
                    dynamicAnimation: { enabled: true, speed: 350 }
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '55%',
                    borderRadius: 4
                }
            },
            dataLabels: { enabled: false },
            stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
            },
            xaxis: {
                categories: [],
                labels: { rotate: -45 }
            },
            yaxis: {

            },
            legend: { position: 'top' },
            tooltip: {
                y: { formatter: val => `${val} khách` }
            },
            responsive: [
                {
                    breakpoint: 768,
                    options: {
                        plotOptions: {
                            bar: { columnWidth: '65%' }
                        },
                        xaxis: {
                            labels: {
                                show: true,
                                rotate: -45
                            }
                        }
                    }
                }
            ]
        };

        return {
            publicPath: process.env.VUE_APP_BASE_URL,
            form: {
                year: new Date().getFullYear().toString(),
                month: '',
                branch_id: '',
                area_id: '',
            },
            ageChartKey: 0,
            total: 0,
            ageTotal: 0,
            objectTotal: 0,
            cache_sale: null,
            drawerCenterVisible: false,
            titleStatisticalCenter: '',

            // series hiển thị & target cho animate
            ageChartSeries: [],
            ageChartSeriesTarget: [],
            objectChartSeries: [],
            objectChartSeriesTarget: [],
            channelChartSeries: [],
            channelChartSeriesTarget: [],
            hotKeyChartSeries: [],
            hotKeyChartSeriesTarget: [],
            centerChartSeries: [],
            centerChartSeriesTarget: [],
            childUsers: [], areas: [], branches: [], options: [],
            listCustomerBranch: [],
            imageHierarchy: {
                '5': 'media/hierarchy/gdvp.png',
                '1': 'media/hierarchy/sl.png',
                '2': 'media/hierarchy/se.png',
                '3': 'media/hierarchy/s.png',
                '4': 'media/hierarchy/si.png'
            },

            centerLabelToId: {
                'Classup': 295,
                'IELTS Mentor': 516,
                'A&U Language Institute': 484,
                'The Book Garden': 481,
                'TOEIC Master': 518,
                'Amate': 479,
                'Gen Z': 233,
                'WorldLink': 483,
                'Cambridge Mentor': 530,
                'Uni': 482,
            },

            ageChartOptions: {
                ...columnStackedOptions,
                chart: {
                    ...columnStackedOptions.chart,
                    type: 'line'
                },
                // màu biểu đồ Độ tuổi khách hàng theo tháng theo từng độ tuổi
                colors: ['#417ABD', '#279FFA','#503694', '#FFD602', '#FF8906', '#05224A'],
                stroke: {
                    curve: 'smooth',
                    width: [0, 0, 0, 0, 0, 3]
                },
                markers: {
                    size: [0, 0, 0, 0, 0, 4]
                }
            },
            objectChartOptions: {
                ...columnStackedOptions,
                colors: ['#503694', '#FFDC28', '#FF8906'],

            },
            channelChartOptions: {
                chart: {
                    toolbar: { show: true },
                    animations: {
                        enabled: true,
                        easing: 'easeinout',
                        speed: 800,
                        animateGradually: { enabled: true, delay: 120 },
                        dynamicAnimation: { enabled: true, speed: 350 }
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        barHeight: '60%',
                        borderRadius: 4
                    }
                },
                dataLabels: { enabled: false },
                xaxis: {
                    categories: [],
                    title: {
                        text: 'Số khách hàng học trung tâm',
                        style: {
                            fontSize: '12px',
                            fontFamily: 'Roboto',
                            fontWeight: 700,
                        }
                    }
                },
                yaxis: {
                    labels: { style: { fontSize: '12px' } }
                },
                tooltip: {
                    y: { formatter: val => `${val} khách` }
                },
                grid: { strokeDashArray: 4 },
                responsive: [
                    {
                        breakpoint: 768,
                        options: {
                            plotOptions: {
                                bar: { barHeight: '70%' }
                            }
                        }
                    }
                ]
            },
            hotKeyChartOptions: {
                chart: {
                    toolbar: { show: true },
                    animations: {
                        enabled: true,
                        easing: 'easeinout',
                        speed: 800,
                        animateGradually: { enabled: true, delay: 120 },
                        dynamicAnimation: { enabled: true, speed: 350 },
                    },
                },
                plotOptions: {
                    bar: { horizontal: true, barHeight: '60%', borderRadius: 4 },
                },
                dataLabels: { enabled: false },
                xaxis: {
                    categories: [],
                    title: {
                        text: 'Số lượng phím nóng / rào cản',
                        style: {
                            fontSize: '12px',
                            fontFamily: 'Roboto',
                            fontWeight: 700,
                        }
                    },
                },
                yaxis: {
                    labels: { style: { fontSize: '12px' } },
                },
                tooltip: {
                    y: { formatter: val => `${val} lượt` },
                },
                grid: { strokeDashArray: 4 },
            },
            centerChartOptions: {
                chart: {
                    toolbar: { show: true },
                    animations: {
                        enabled: true,
                        easing: 'easeinout',
                        speed: 800,
                        animateGradually: { enabled: true, delay: 120 },
                        dynamicAnimation: { enabled: true, speed: 350 },
                    },
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        barHeight: '60%',
                        borderRadius: 4,
                    },
                },
                dataLabels: { enabled: false },
                xaxis: {
                    categories: [],
                    title: {
                        text: 'Số khách theo trung tâm',
                        style: {
                            fontSize: '12px',
                            fontFamily: 'Roboto',
                            fontWeight: 700,
                        }
                    },
                },
                yaxis: {
                    labels: { style: { fontSize: '12px' } },
                },
                tooltip: {
                    y: { formatter: val => `${val} khách` },
                },
                grid: { strokeDashArray: 4 },
            },
        }
    },

    mounted () {
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Thống kê số liệu khách hàng", icon: 'far fa fa-chart-bar' }
        ]);
        this.getCenter();
        this.getRegions();
        this.getChartData();
        this.getChildUser();
    },

    methods: {
        getChartData() {
            const payload = this.form;
            this.$store.dispatch(GET_CHART_DATA, payload)
                .then((res) => {
                    if (res.status === 422) {
                        this.$message({
                            type: 'warning',
                            message: `${res.message}`,
                            showClose: true
                        });
                        return;
                    }
                    const data          = res.data || {};
                    const ageChart      = data.age_chart || {};
                    const channelChart  = data.channel_chart || {};
                    const objectChart   = data.object_chart || {};
                    const centerChart   = data.center_chart || {};

                    const ageSeriesTarget     = ageChart.series || [];
                    const channelSeriesTarget = channelChart.series || [];
                    const objectSeriesTarget  = objectChart.series || [];
                    const centerSeriesTarget  = centerChart.series || [];

                    const ageCategories     = ageChart.categories || [];
                    const channelCategories = channelChart.categories || [];
                    const objectCategories  = objectChart.categories || [];
                    const centerCategories    = centerChart.categories || [];

                    const hotKeyChart  = data.hot_key_chart || {};
                    const hotKeySeriesTarget = hotKeyChart.series || [];
                    const hotKeyCategories   = hotKeyChart.categories || [];

                    // tổng từ API
                    this.total = data.total || 0;

                    // cập nhật categories cho 3 chart
                    this.ageChartOptions = {
                        ...this.ageChartOptions,
                        xaxis: {
                            ...(this.ageChartOptions.xaxis || {}),
                            categories: ageCategories
                        }
                    };

                    this.channelChartOptions = {
                        ...this.channelChartOptions,
                        xaxis: {
                            ...(this.channelChartOptions.xaxis || {}),
                            categories: channelCategories
                        }
                    };

                    this.objectChartOptions = {
                        ...this.objectChartOptions,
                        xaxis: {
                            ...(this.objectChartOptions.xaxis || {}),
                            categories: objectCategories
                        }
                    };

                    this.hotKeyChartOptions = {
                        ...this.hotKeyChartOptions,
                        xaxis: {
                            ...(this.hotKeyChartOptions.xaxis || {}),
                            categories: hotKeyCategories,
                        },
                    };

                    this.centerChartOptions = {
                        ...this.centerChartOptions,
                        xaxis: {
                            ...(this.centerChartOptions.xaxis || {}),
                            categories: centerCategories,
                        },
                    };

                    // lưu target
                    this.ageChartSeriesTarget     = ageSeriesTarget;

                    this.channelChartSeriesTarget = channelSeriesTarget;
                    this.objectChartSeriesTarget  = objectSeriesTarget;
                    this.hotKeyChartSeriesTarget = hotKeySeriesTarget;
                    this.centerChartSeriesTarget  = centerSeriesTarget;

                    // tính tổng cho tuổi (bỏ series line) & đối tượng
                    const sumSeries = (seriesArr) =>
                        seriesArr.reduce(
                            (total, s) =>
                                total + (s.data || []).reduce((a, b) => a + b, 0),
                            0
                        );

                    this.ageTotal    = sumSeries(ageSeriesTarget.filter(s => s.type !== 'line'));
                    this.objectTotal = sumSeries(objectSeriesTarget);

                    this.ageChartSeries = ageSeriesTarget || [];
                    this.ageChartKey += 1;

                    this.ageChartSeries = ageSeriesTarget.map(s => ({
                        ...s,
                        data: (s.data || []).map(() => 0)
                    }));
                    this.channelChartSeries = channelSeriesTarget.map(s => ({
                        ...s,
                        data: (s.data || []).map(() => 0)
                    }));

                    this.objectChartSeries = objectSeriesTarget.map(s => ({
                        ...s,
                        data: (s.data || []).map(() => 0)
                    }));

                    this.hotKeyChartSeries = hotKeySeriesTarget.map(s => ({
                        ...s,
                        data: (s.data || []).map(() => 0),
                    }));

                    this.centerChartSeries = centerSeriesTarget.map(s => ({
                        ...s,
                        data: (s.data || []).map(() => 0),
                    }));

                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.ageChartSeries     = this.ageChartSeriesTarget;
                            this.channelChartSeries = this.channelChartSeriesTarget;
                            this.objectChartSeries  = this.objectChartSeriesTarget;
                            this.hotKeyChartSeries = this.hotKeyChartSeriesTarget;
                            this.centerChartSeries  = this.centerChartSeriesTarget;
                        }, 200);
                    });
                });
        },

        getImageHierarchy(account_type) {
            return this.imageHierarchy[account_type];
        },

        normalizer (node) {
            return {
                id: node.id,
                label: node.name,
            }
        },

        handleChangeSale() {
            this.form.sale = this.cache_sale;
            if (!this.form.sale) {
                this.form.view_as = '';
            }
            this.getChartData();
        },

        getCenter() {
            const payload = {
                area_id: this.form.area_id
            };

            this.$store.dispatch(BRANCH_LIST, payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.branches = response.data;
                    }
                });
        },

        getRegions() {
            const payload = {
                all: this.keyAccount === 7 ? 1 : 0
            };
            this.$store.dispatch(GET_REGIONS_BY_USER, payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.areas = response.data;
                    }
                });
        },

        getChildUser() {
            let branchId = '';
            if ([1,5].includes(this.currentUser.account_type.id)) {
                branchId = this.currentUser.profile.chi_nhanh_id;
            }
            const payload = {
                branch_id: this.form.branch_id || branchId,
            };
            this.$store.dispatch(GET_CHILD_USER, payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.childUsers = response.data;
                        this.options = response.data;
                    }
                });
        },

        onCenterPointClick(event, chartContext, config) {
            const dataIndex = config?.dataPointIndex;

            if (dataIndex === undefined || dataIndex === null || dataIndex < 0) {
                return;
            }

            const categories = config.w.config.xaxis.categories || [];
            console.log('categories', categories)

            const label = categories[dataIndex];

            const centerId = this.centerLabelToId[label];
            this.titleStatisticalCenter = `Khách hàng trung tâm ${label}`;

            if (!centerId) {
                console.warn('Không tìm thấy center_id cho label:', label);
                return;
            }

            const payload = {
                ...this.form,
                center_id: centerId,
            };

            this.$store.dispatch(GET_CUSTOMER_CHART_BY_CENTER, payload)
                .then((res) => {
                    if (res.status === 422) {
                        this.$message({type: 'warning', message: `${res.message}`, showClose: true});
                    } else {
                        this.listCustomerBranch = res.data ?? [];
                        this.drawerCenterVisible = true;
                    }
                });
        },

    },

    computed: {
        ...mapGetters(["currentUser", "keyAccount"]),
        displayYear() {
            return this.form.year || new Date().getFullYear().toString();
        }
    }
}
</script>

<style scoped>
.panel-container {
    width: 100%;
    background-color: rgb(255, 255, 255);
    box-shadow: none;
}
.analytics-page {
    padding: 16px 24px;
    min-height: 100%;
    background: #f4f5fb;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.page-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 4px;
}

.page-title {
    font-size: 20px;
    font-weight: 600;
    color: #111827;
    margin: 0;
}

.page-subtitle {
    font-size: 13px;
    color: #6b7280;
    margin-top: 4px;
}

.charts-grid {
    display: grid;
    grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);
    gap: 16px;
}

.chart-card {
    background: #ffffff;
    padding: 16px 18px 12px;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
    display: flex;
    flex-direction: column;
}

.chart-header {
    margin-bottom: 8px;
}

.chart-title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    margin: 0;
}

.chart-sub {
    font-size: 12px;
    color: #6b7280;
    margin-top: 2px;
}

@media (max-width: 1024px) {
    ::v-deep .apexcharts-reset-icon,
    ::v-deep .apexcharts-pan-icon,
    ::v-deep .apexcharts-zoomout-icon,
    ::v-deep .apexcharts-zoomin-icon
    {
        display: none;
    }
}


/* Mobile */
@media (max-width: 768px) {
    .analytics-page {
        padding: 12px 12px 16px;
    }

    .charts-grid {
        grid-template-columns: minmax(0, 1fr);
    }

    .chart-card {
        padding: 12px 10px;
        border-radius: 14px;
        box-shadow: 0 4px 16px rgba(15, 23, 42, 0.06);
    }

    .chart-title {
        font-size: 15px;
    }

    .chart-sub {
        font-size: 11px;
    }
}

.drawer-header {
    margin-bottom: 12px;
}

.drawer-title {
    font-size: 18px;
    font-weight: 600;
    color: #111827;
}

.drawer-subtitle {
    font-size: 12px;
    color: #6b7280;
    margin-top: 2px;
}

.drawer-body {
    flex: 1;
    overflow-y: auto;
    padding-right: 4px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.branch-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    border-radius: 12px;
    background: #ffffff;
    box-shadow: 0 4px 12px rgba(148, 163, 184, 0.15);
    transition: transform .15s ease, box-shadow .15s ease;
}

.branch-row:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 20px rgba(148, 163, 184, 0.25);
}

.branch-main {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.branch-name {
    font-size: 14px;
    font-weight: 600;
    color: #111827;
    display: flex;
    align-items: center;
    gap: 6px;
}

.branch-index {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 999px;
    background: #eef2ff;
    color: #4f46e5;
    font-size: 11px;
    font-weight: 600;
}

.branch-id {
    font-size: 11px;
    color: #9ca3af;
}

.branch-total {
    text-align: right;
}

.total-number {
    font-size: 20px;
    font-weight: 700;
    color: #2563eb;
}

.total-label {
    font-size: 11px;
    color: #6b7280;
}

.drawer-empty {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    color: #6b7280;
}

</style>
